import React from "react";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLayerGroup,
  faPencil
} from "@fortawesome/free-solid-svg-icons";

const RRCategoriasRRHH = ({c,index,handleEditCategoria}) =>{

    const disabled = true;

    return <div className="rrCatsRRHHDiv">
            <FontAwesomeIcon icon={faLayerGroup} className="rrIcon"/>
            <div className="infoDiv">
                <h6>Codigo:</h6>
                <label>{c.codigo}</label>
            </div>
            <div className="infoDiv">
                <h6>Descripción:</h6>
                <label>{c.descrp}</label>
            </div>
            <div className="infoDiv">
                <h6>Sueldo Básico:</h6>
                <label className={(disabled) ? 'disabledText' : ''}>${(disabled) ? 'XXXXXX' : c.basico}</label>
            </div>
            <div className="infoDiv">
                <h6>Básico por Hora:</h6>
                <label className={(disabled) ? 'disabledText' : ''}>${(disabled) ? 'XXXXXX' : c.basicoHora}</label>
            </div>
            <div className="infoDiv">
                <h6>%Adicional:</h6>
                <label className={(disabled) ? 'disabledText' : ''}>${(disabled) ? 'XXXXXX' : c.adicional}</label>
            </div>
            <div className="utilitesDiv" onClick={()=>handleEditCategoria(c)}>
                <FontAwesomeIcon className="utilityIcon" icon={faPencil}/>
            </div>
    </div>

}

export default RRCategoriasRRHH;